import * as React from 'react'
import {useTemperatureUnitContext} from "context/TemperatureUnitContext";
import { convertToFahrenheit } from "services/convertUnits";

export const Degrees = ({degrees}: {degrees: any}) => {
    const [unit] = useTemperatureUnitContext()
    let convertedDegrees = degrees
    if (unit === 'F') convertedDegrees = convertToFahrenheit(degrees)

    return <>{`${convertedDegrees.toFixed(0)} °${unit}`}</>

}
